export enum ApiResetPasswordKnownErrorsEnum {
  RESET_PASSWORD_TOKEN_NOT_FOUND = 'RESET_PASSWORD_TOKEN_NOT_FOUND',
  RESET_PASSWORD_TOKEN_EXPIRED = 'RESET_PASSWORD_TOKEN_EXPIRED',
  RESET_PASSWORD_REUSE_NOT_ALLOWED = 'RESET_PASSWORD_REUSE_NOT_ALLOWED',
}
